import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';

const SearchBar = ({ searchTerm, onSearchChange, onSearchKeyPress }) => {
  return (
    <TextField
      fullWidth
      placeholder="Search by event ID"
      value={searchTerm}
      size="medium"
      onChange={onSearchChange}
      onKeyDown={onSearchKeyPress}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
        sx: { fontSize: '0.875rem', padding: '1px', paddingRight: '1rem' },
      }}
      sx={{ minWidth: 400, padding: '1px', marginBottom: '1rem' }}
    />
  );
};

export default SearchBar;
